import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import get from 'lodash/get';
import NavItem from './NavItem';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

function NavItems({ children, items, primary }) {
  const itemRefs = Array(items.length)
    .fill()
    .map((_, i) => createRef());

  const [activeItem, setActiveItem] = useState('none');
  const handleMouseEnter = (idx) => {
    setActiveItem(idx);
  };

  const handleMouseLeave = () => {
    setActiveItem('none');
  };

  return (
    <Wrapper onMouseLeave={handleMouseLeave}>
      {items.map((item, idx) => (
        <NavItem
          key={idx}
          idx={idx}
          {...item}
          item={item}
          primary={primary}
          activeItem={activeItem}
          onMouseEnter={() => {
            if (
              item.forceDescriptionDisplay ||
              (Array.isArray(get(items[idx], 'childRoutes')) &&
                items[idx].childRoutes.length > 0)
            ) {
              handleMouseEnter(idx);
            } else {
              handleMouseLeave();
            }
          }}
          ref={itemRefs[idx]}
        />
      ))}
    </Wrapper>
  );
}

NavItems.propTypes = {
  children: PropTypes.node,
  items: PropTypes.array.isRequired,
  primary: PropTypes.bool,
};

export default NavItems;

